export const ORGANIZATION_STORE = 'ORGANIZATION_STORE';
export const ORGANIZATION_UPDATE = 'ORGANIZATION_UPDATE';
export const ORGANIZATION_DESTROY = 'ORGANIZATION_DESTROY';
